import React from 'react';
import styled from 'styled-components';
import { toFriendlyDateString } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';
import ProjectEditing from './ProjectEditing';
import Col from 'components/ui/Col';
import loadingGif from 'assets/yuhu-loading.gif';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

const ScrollablePanel = styled.div`
  height: 100%;
  overflow: scroll;
  ${media.mobile`
    padding-bottom: 50px;
  `};
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: center;
  padding: 32px 32px 0;
  max-width: 525px;
  margin: auto;
  flex-wrap: wrap;

  ${media.mobile`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
  `};
`;

const StyledGreyBox = styled.div`
  background: #f3f3f7;
  border-radius: 16px;
  padding: 15px;
`;

const StyledGreySquare = styled(StyledGreyBox)`
  text-align: center;
  width: 162px;
  height: 156px;
  margin-bottom: 32px;
  margin-left: 32px;

  ${media.mobile`
    margin-top: 15px;
    margin-left: 0;
    width: 90%;
  `};
`;

const StyledValue = styled.div`
  font-weight: bold;
  font-size: ${props => props.fontSize || '16px'};
  padding: ${props => props.padding || '0px'};
`;

const StyledCol = styled(Col)`
  ${media.mobile`
    margin-bottom: 32px;
  `};
`;

const StyledLabel = styled.div`
  font-size: ${props => props.fontSize || '16px'};
`;

const StyledImgContainer = styled.div`
  display: flex;
  margintop: 32px;
`;

const StyledLoader = styled.img`
  width: 200px;
  margin: auto;
`;

const ProjectOverview = ({
  numTicketsLinked = 0,
  numPurchaseOrders = 0,
  dueDate,
  dateCreated,
  selectedProject,
  properties,
  units,
  fetchUnitsOfProperty,
  fetchProject,
  putProject,
}) => {
  if (Object.keys(selectedProject).length === 0 && selectedProject.constructor === Object)
    return (
      <StyledImgContainer shouldRender>
        <StyledLoader src={loadingGif} alt="loader" />
      </StyledImgContainer>
    );

  return (
    <ScrollablePanel>
      <StyledCol xs={24} sm={24} md={12}>
        <StyledContainer>
          <GreySquare
            value={numTicketsLinked}
            label={getTranslatedString('landlordPortal.maintenance.projects.ticketsTabHeader')}
          />
          <RenderIfToggleOn toggle="purchase_order">
            <GreySquare
              value={numPurchaseOrders}
              label={getTranslatedString(
                'landlordPortal.maintenance.projects.purchaseOrdersTabHeader'
              )}
            />
          </RenderIfToggleOn>
          <GreySquare
            value={toFriendlyDateString(dueDate) || '-'}
            label={getTranslatedString('landlordPortal.maintenance.projects.dueDate')}
            valueFontSize="22px"
            padding="20px 0 21px"
          />
          <GreySquare
            value={toFriendlyDateString(dateCreated) || '-'}
            label={getTranslatedString('landlordPortal.maintenance.projects.dateCreated')}
            valueFontSize="22px"
            padding="20px 0 21px"
          />
        </StyledContainer>
      </StyledCol>
      <Col xs={24} sm={24} md={12}>
        <ProjectEditing
          selectedProject={selectedProject}
          properties={properties}
          units={units}
          fetchUnitsOfProperty={fetchUnitsOfProperty}
          fetchProject={fetchProject}
          putProject={putProject}
        />
      </Col>
    </ScrollablePanel>
  );
};

const GreySquare = ({ value, label, valueFontSize, padding }) => {
  return (
    <StyledGreySquare>
      <StyledValue padding={padding} fontSize={valueFontSize || '50px'}>
        {value}
      </StyledValue>
      <StyledLabel>{label}</StyledLabel>
    </StyledGreySquare>
  );
};

export default ProjectOverview;
